import { toast } from 'react-toastify'

import { api } from 'api'
import { Success } from 'constants/actionMessages'
import { UpdateTetrisDefaultPriceParams } from 'interfaces/store/tetrisDefaultPrices.interfaces'
import { createAsyncThunk } from 'modules/store'

export const getAllTetrisDefaultPrices = createAsyncThunk(
  'tetrisDefaultPrices/getAllTetrisDefaultPrices',
  async (_, { rejectWithValue }) => api.tetrisDefaultPrices.getAll().catch((error) => rejectWithValue(error.message)),
)

export const updateTetrisDefaultPrice = createAsyncThunk(
  'tetrisDefaultPrices/updateTetrisDefaultPrice',
  async (params: UpdateTetrisDefaultPriceParams, { rejectWithValue, dispatch }) =>
    api.tetrisDefaultPrices
      .update(params.data)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(getAllTetrisDefaultPrices())
        toast.success(Success.Save)
      })
      .catch((error) => rejectWithValue(error.message)),
)
